export default {
    featureEffectPath: "/features/effect",
    featureModelPath: "/features/model",
    featureUpdatePath: "/features/update",
    managerAggregatePath: "/manager/aggregate",
    managerAnalyzePath: "/manager/analyze",
    operationLogPath: "/operation/log",
    operationApiPath: "/operation/api",
    operationSafePath: "/operation/safe",
}